import { createSelector } from 'reselect';
import { getBatch } from '../rootSelectors';

const getBatchMachineRange = createSelector([getBatch], batch => batch.batchMachineRange);
const getBatchSortOrder = createSelector([getBatch], batch => batch.batchSortOrder);
const getBatchFilter = createSelector([getBatch], batch => batch.batchFilter);
const getSelectedBatchRecord = createSelector([getBatch], batch => batch.data);

export { getBatchMachineRange, getBatchSortOrder, getBatchFilter, getSelectedBatchRecord };
